import RuleBuilder from 'services/simplex/rule-builder';
import {getSimplexUnitName} from 'helpers/simplex-helper';
import {isPlayerOnDoublePosition} from 'helpers/player-helper';

export class RestrictedPlayersSimplexConstraintsBuilder {
    private combosMap: object = {};
    private sportConfig: object;
    private playersList;
    private playersExclusion;
    private csPlayers;
    private checkIfPlayerOnDoublePosition: boolean;

    constructor(dependencies) {
        const {csPlayers, players, playersExclusion, checkIfPlayerOnDoublePosition = false, sportConfig} = dependencies;

        this.csPlayers = csPlayers;
        this.playersList = players;
        this.playersExclusion = playersExclusion;
        this.checkIfPlayerOnDoublePosition = checkIfPlayerOnDoublePosition;
        this.sportConfig = sportConfig;
    }

    public setCombosMap(combosMap): void {
        this.combosMap = combosMap;
    }

    private isPlayerOnSinglePosition(playerId): boolean {
        if (!this.checkIfPlayerOnDoublePosition) {
            return true;
        }

        const player = this.playersList.getPlayer(playerId);

        return !(player && isPlayerOnDoublePosition(player));
    }

    private getSimplexUnitNamesByPlayerId(playerId): string[] {
        if (this.isPlayerOnSinglePosition(playerId)) {
            return [getSimplexUnitName(playerId)];
        }

        const player = this.playersList.getPlayer(playerId);

        if (!player) {
            return [getSimplexUnitName(playerId)];
        }

        return player.position.map((positionKey) => getSimplexUnitName([playerId, positionKey]));
    }

    private createPlayersMap(combosMap, forPlayerIds) {
        const map = {};

        Object.values(combosMap).map((teamMap) => {
            // @ts-ignore
            Object.values(teamMap).map((items) => {
                // @ts-ignore
                Object.values(items).map((item) =>
                    // @ts-ignore
                    item.playerIds.map((playerId) => {
                        if (!inArray(playerId, forPlayerIds)) {
                            return;
                        }
                        if (!map.hasOwnProperty(playerId)) {
                            map[playerId] = [];
                        }
                        // @ts-ignore
                        map[playerId].push(item.keyUnitId);
                    }),
                );
            });
        });
        // @ts-ignore
        Object.values(map).map((keyUnitIds) => keyUnitIds.sort());

        return map;
    }

    private createCombosMap(playerMap) {
        const map = {};

        Object.keys(playerMap).map((playerId) => {
            const key = playerMap[playerId].sort().join('');
            if (!map.hasOwnProperty(key)) {
                map[key] = {
                    playerIds: [],
                    keyUnitIds: playerMap[playerId],
                };
            }
            map[key].playerIds.push(playerId);
        });

        return map;
    }

    private createRules() {
        const rules = [];

        const playerIds = this.csPlayers.getRestrictedPlayerIds();

        if (isEmpty(playerIds)) {
            return rules;
        }

        const playersMap = this.createPlayersMap(this.combosMap, playerIds);
        const combosMap = this.createCombosMap(playersMap);
        // console.log('playersMap',{...playersMap});
        // console.log('combosMap',{...combosMap});
        Object.values(combosMap).map((combo) => {
            // @ts-ignore
            const playersQuantity = combo.playerIds.length;
            const builder = RuleBuilder.fromAtLeast(0);
            // @ts-ignore
            combo.playerIds.map((id) =>
                this.getSimplexUnitNamesByPlayerId(id).map((simplexUnitName) => {
                    builder.addVar(simplexUnitName, -1);
                }),
            );
            // @ts-ignore
            combo.keyUnitIds.map((id) => builder.addVar(id, playersQuantity));
            // @ts-ignore
            rules.push(builder.createRule());
        });

        const forbiddenPlayersRow = {};
        playerIds.map((pId) => {
            if (playersMap.hasOwnProperty(pId)) {
                return;
            }

            const player = this.playersList.getPlayer(pId);
            if (player.isExcludedAnywhere(this.playersExclusion)) {
                return;
            }

            this.getSimplexUnitNamesByPlayerId(pId).map((simplexUnitName) => {
                forbiddenPlayersRow[simplexUnitName] = 1;
            });
        });

        if (!isEmpty(forbiddenPlayersRow)) {
            const builder = RuleBuilder.fromExactly(0);
            builder.addVars(forbiddenPlayersRow);
            // @ts-ignore
            rules.push(builder.createRule());
        }

        return rules;
    }

    public getRules(): object[] {
        const rules = this.createRules();
        // console.log('rules',{...rules});
        return [...rules];
    }
}
